import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";

const WARN_DAYS = 30; // show banner when this many days remain

export default function SubscriptionBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  // Reset dismissal state whenever validity_date changes (e.g., after renewal)
  const storageKey = user?.validity_date ? `sub_banner_dismissed_${user.validity_date}` : null;

  useEffect(() => {
    if (!storageKey) return;
    setDismissed(localStorage.getItem(storageKey) === "1");
  }, [storageKey]);

  const dismiss = () => {
    if (storageKey) localStorage.setItem(storageKey, "1");
    setDismissed(true);
  };

  if (!user || !user.validity_date || dismissed) return null;

  const today  = new Date();
  today.setHours(0, 0, 0, 0);
  const expiry = new Date(user.validity_date);
  expiry.setHours(0, 0, 0, 0);
  const daysLeft = Math.floor((expiry - today) / 86400000);

  if (daysLeft > WARN_DAYS) return null;

  const expired = daysLeft < 0;
  const critical = daysLeft <= 1;

  const bg      = expired ? "#dc3545" : critical ? "#dc3545" : daysLeft <= 7 ? "#fd7e14" : "#ffc107";
  const textCol = "#fff";

  let message;
  if (expired) {
    message = "Your subscription has expired. Please renew to continue using all features.";
  } else if (daysLeft === 0) {
    message = "Your subscription expires today! Please renew to avoid interruption.";
  } else {
    message = `Your subscription expires in ${daysLeft} day${daysLeft !== 1 ? "s" : ""} (${expiry.toLocaleDateString("en-US", { day: "numeric", month: "short", year: "numeric" })}). Please renew soon.`;
  }

  return (
    <div style={{
      position: "fixed",
      top: 60,
      right: 16,
      zIndex: 1200,
      maxWidth: 360,
      background: bg,
      color: textCol,
      borderRadius: 10,
      boxShadow: "0 4px 20px rgba(0,0,0,0.18)",
      padding: "10px 14px 10px 16px",
      display: "flex",
      alignItems: "flex-start",
      gap: 10,
      fontSize: 13,
      lineHeight: 1.45,
    }}>
      <span style={{ flex: 1 }}>
        <strong style={{ display: "block", marginBottom: 2 }}>
          {expired ? "Subscription Expired" : "Subscription Expiring Soon"}
        </strong>
        {message}
      </span>
      <button
        onClick={dismiss}
        title="Dismiss"
        style={{
          background: "none",
          border: "none",
          color: textCol,
          cursor: "pointer",
          fontSize: 16,
          lineHeight: 1,
          padding: "0 2px",
          opacity: 0.8,
          flexShrink: 0,
          marginTop: 1,
        }}
      >
        ✕
      </button>
    </div>
  );
}
